(() => {
  const selector = ".rez-stock-notification-button";

  function squareNotifyButton(element) {
    if (element.matches(selector)) element.style.borderRadius = "0";
    element.querySelectorAll(selector).forEach((button) => {
      button.style.borderRadius = "0";
    });
  }

  function initialize() {
    const main = document.getElementById("MainContent");
    if (!main) return;
    squareNotifyButton(main);
    const observer = new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes.forEach((node) => {
          if (node instanceof Element) squareNotifyButton(node);
        });
      });
    });
    observer.observe(main, { childList: true, subtree: true });
  }

  initialize();
})();
